/* tslint:disable:variable-name */
export class MapControllerConfig {
  beacon_animation: boolean = false
  beacon_display: boolean = true
  env_info_display: boolean = true
}

export type MapControllerType = 'beacon_animation' | 'beacon_display' | 'env_info_display'
